import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import { googleOAuth, login } from "../Store/AuthThunk";
import validator from "validator";

import ApiHelper from "../../../Helpers/ApiHelper";
import Overlay from "../../SharedComponents/Overlay";
import { GoogleButton } from "./OAuth/Google/GoogleButton";
import { setRememberMe } from "../Store";
import TalentTurkLogo from "./TalentTurkLogo";
import CusProLogo from "./CusProLogo";
import AdminBreadCrumb from "../../Admin/AdminBreadCrumb";
import Image from "react-bootstrap/Image";


const NewLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const userAtRedux = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const rememberMe = useSelector((state) => state.auth.rememberMe);

  useEffect(() => {
    if (userAtRedux?.userRole) {
      CheckUserHandleNavigate(userAtRedux);
    }
  }, [userAtRedux]);

  const CheckUserHandleNavigate = (user) => {
    if (!user?.userRole) return;

    // Always persist the session so a page refresh or a new tab restores the login.
    // (localStorage is shared across tabs and survives refresh; redux state is per-tab
    // and lost on refresh, which is what was kicking users out.)
    localStorage.setItem("cpdata", JSON.stringify(user));

    if (user.userRole === "SuperAdmin") {
      navigate("/sdash");
    } else if (user.userRole === "Admin") {
      if (state?.wrapUpId) {
        navigate("/wrapup/" + state?.wrapUpId);
      } else navigate("/dash");
    } else if (user.userRole === "User") {
      navigate("/userdash");
    }
  };

  const [showOverlay, setShowOverlay] = useState(false);

  const [postData, setPostData] = useState({
    email: "",
    password: "",
  });

  const [validation, setValidation] = useState({
    mail: null,
    password: null,
  });

  const [modal, setModalShow] = useState({
    show: false,
  });

  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);

  let SendNewPassword = () => {
    setShowOverlay(true);
    // Secure flow: request a reset LINK. The endpoint always returns a generic success
    // message (it never reveals whether the account exists) and never resets the password
    // until the emailed token is used.
    ApiHelper.postAsync("user/ForgotPassword", { email: postData.email }, function (result) {
      setShowOverlay(false);
      setForgotPasswordModal(false);

      if (result.status === 200) {
        setModalShow(() => ({
          show: true,
          text: result.data?.message || t("requestSuccess"),
          heading: "Başarılı",
        }));
      } else {
        setModalShow(() => ({
          show: true,
          text: result.data?.message || t("requestFailed"),
          heading: "Hata",
        }));
      }
    });
  };

  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  let onSubmit = async () => {
    // Read straight from the inputs so autofilled values are captured even when the
    // browser doesn't fire onChange (Chrome and Edge differ here) and trim stray
    // whitespace on the email. Do NOT enforce password-complexity on login.
    const email = (emailRef.current?.value ?? postData.email ?? "").trim();
    const password = passwordRef.current?.value ?? postData.password ?? "";

    if (!email || !password) {
      setModalShow(() => ({ show: true, heading: "Hata", text: t("invalidEmail") }));
      return;
    }

    const result = await dispatch(login({ email, password }));
    if (login.fulfilled.match(result)) {
      CheckUserHandleNavigate(result.payload);
    } else {
      setModalShow(() => ({
        show: true,
        text: result.payload || t("requestFailed"),
        heading: "Hata",
      }));
    }
  };

  let OnSubmitGoogleOAuth = async (token) => {
    const result = await dispatch(googleOAuth({ token }));
    if (googleOAuth.fulfilled.match(result)) {
      CheckUserHandleNavigate(result.payload);
    } else {
      setModalShow(() => ({
        show: true,
        text: result.payload || t("requestFailed"),
        heading: "Hata",
      }));
    }
  };

  let checkValidationAndSet = (value, inputType) => {
    if (inputType === "mail") {
      setPostData((postData) => ({ ...postData, email: value }));
      if (!validator.isEmail(value)) {
        setValidation((validation) => ({ ...validation, mail: true }));
      } else {
        setValidation((validation) => ({ ...validation, mail: false }));
      }
    } else if (inputType === "password") {
      // Login must accept whatever password the account has — do not apply the
      // registration complexity rules here (that only gated the submit button and
      // broke logins for autofilled or non-matching-but-valid passwords).
      setPostData((postData) => ({ ...postData, password: value }));
    }
  };

  let modalClose = () => {
    if (modal.succes) navigate("/login");
    else setModalShow(false);
  };

  return (
    <>
      {(isLoading || showOverlay) && (
        <Overlay text={showOverlay ? t("resetPasswordSending") : "Bilgiler kontrol ediliyor"} />
      )}

      <Row className={"vh-100"}>
        <Col xs={"auto"} className={"d-none position-relative d-lg-block p-0"} style={{ width: 500 }}>
          <div className={"top-0 bottom-0 position-absolute z-0 animate__animated animate__fadeInLeft"}>
            <Image
              src={"/LandingPageImages/puzzleLight.webp"}
              alt="example"
              style={{
                width: "500px",
                height: "100vh",
                objectFit: "cover", // key: makes image fill and crop
                objectPosition: "center", // optional: center the crop
              }}
            />
          </div>

          <div className={"top-0 bottom-0 start-0 end-0 position-absolute z-1 animate__animated animate__fadeIn"}>
            <Row className={"justify-content-between ms-3 me-1 mt-2"}>
              <Col xs={"auto"} className={"mt-1"}>
                <CusProLogo size={40} fill={"#fff"} />
              </Col>
              <Col xs={"auto"}>
                <TalentTurkLogo size={40} fill={"#fff"} />
              </Col>
            </Row>
          </div>
        </Col>
        <Col xs={12} lg={true}>
          <Row className={"mt-2 mx-0 "}>
            <Col xs={"auto"}>
              <AdminBreadCrumb className={"mb-0"} backUrl={"/"}></AdminBreadCrumb>
            </Col>
            <Col className={"p-0"}></Col>
            <Col xs={"auto"} className={"text-color-gray-light align-content-center d-none d-sm-block"}>
              {t("dontHaveAnAccountYet?")}
            </Col>
            <Col xs={"auto"}>
              <Button className={"button secondary h-100"} onClick={() => navigate("/register")}>
                {t("register")}
              </Button>
            </Col>
          </Row>
          <Form className={"mt-5 pt-4 animate__animated animate__fadeIn"}>
            <Row className={"justify-content-center"}>
              <Col xs={9} xxl={7}>
                <Row className={"text-color-gray-dark text-24 fw-medium"}> {t("loginToCusProAccount")}</Row>

                <Row className={"mt-5"}>
                  <Col>
                    <Row className={"text-color-gray-light"}> {t("email")}</Row>
                    <Row>
                      <Form.Control
                        ref={emailRef}
                        className={"default-text-input"}
                        placeholder={t("yourEmail")}
                        type="email"
                        onChange={(e) => checkValidationAndSet(e.target.value, "mail")}
                        isInvalid={validation.mail}
                        value={postData.email}
                        autoComplete="email"
                      ></Form.Control>
                    </Row>
                  </Col>
                </Row>
                <Row className={"mt-3"}>
                  <Col>
                    <Row className={"text-color-gray-light justify-content-between"}>
                      <Col xs={"auto"} className={"p-0"}>
                        {t("password")}
                      </Col>
                      <Col
                        xs={"auto"}
                        className={"link-info show-cursor p-0"}
                        onClick={() => setForgotPasswordModal(true)}
                      >
                        {t("iForgotMyPassword")}
                      </Col>
                    </Row>
                    <Row>
                      <Form.Control
                        ref={passwordRef}
                        className={"default-text-input"}
                        type="password"
                        placeholder={t("yourPassword")}
                        onChange={(e) => checkValidationAndSet(e.target.value, "password")}
                        autoComplete="current-password"
                      ></Form.Control>
                    </Row>

                    <Row className={"mt-3"}>
                      <Form.Check
                        className={`default-check-input ${rememberMe ? "text-color-primary" : "text-color-gray-light"}`}
                        type="switch"
                        id="custom-switch"
                        label={t("rememberMe")}
                        checked={rememberMe}
                        onChange={(e) => dispatch(setRememberMe(e.target.checked))}
                      />
                    </Row>
                  </Col>
                </Row>
                <Row className={"mt-5"}>
                  <Col className={"p-0"}>
                    <Button
                      className={"button primary w-100 py-2"}
                      onClick={onSubmit}
                    >
                      {t("loginToCusPro")}
                    </Button>
                  </Col>
                </Row>
                <Row className={"mt-4 justify-content-center"}>
                  <Col xs={"auto"} className={"text-color-gray-light text-14"}>
                    Yada
                  </Col>
                </Row>

                <Row className={"mt-4 justify-content-center"}>
                  <Col xs={"auto"} className={"text-color-gray-light text-14"}>
                    <GoogleButton OnSubmitGoogleOAuth={OnSubmitGoogleOAuth} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>

      <Modal show={forgotPasswordModal} onHide={() => setForgotPasswordModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("resetPasswordTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-color-gray-light mb-3">{t("resetPasswordInfo")}</p>
          <Form.Control
            placeholder={t("yourEmail")}
            type="email"
            onChange={(e) => checkValidationAndSet(e.target.value, "mail")}
            isInvalid={validation.mail}
            value={postData.email}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={SendNewPassword} disabled={validation.mail !== false}>
            {t("send")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={modal.show} onHide={modalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modal.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.text}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={modalClose}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default NewLogin;
